import { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import TableComponent from "../../components/TableComponent";
import { SearchFilter } from "../../models/DashboardModels";
import {
  addSelectedBulkAssignData,
  clearSelectedBulkAssignData,
  handleApplicationSearchDataSlice,
  handleCustomerDetailsSearchDataSlice,
  handleGrievanceDetailsDataSlice,
  handleGrievanceDocUploadSlice,
  handlePolicyDetailsSearchDataSlice,
  handleSearchDataSlice,
  handleSelectedApplication,
  handleStoreDeleteGrievance,
  handleStoreGrievanceFeedbackInfo,
  handleUpdateGrievanceDetailsSlice,
  removeSelectedBulkAssignData
} from '../../redux/slices/grievancesSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  departmentMastersApi,
  finalDispositionMastersApi,
  getDocsApi,
  grievanceDashboardApi,
  grievanceDetailsApi,
  grievanceModeMastersApi,
  grievanceSourceMastersApi,
  getGrievanceTypeMastersApi,
  lineOfBusinessMastersApi,
  seasonnMastersApi,
  stateMasterApi,
  statusMastersApi,
  typeOfRequestMastersApi,
  getGrievanceDescriptionsApi,
  severityMastersApi,
} from "../../api/grievancesApi";
import { FormUtils } from "../../utils/FormUtils";
import NewGrievance from "../../modals/NewGrievanceFormModal";
import ViewGrievance from "../../modals/ViewGrievanceModal";
import { CLICK_ACTIONS, DEFAULT_OPTION, STATUS, TYPE_OF_REQUEST_ID } from "../../utils/Constant";
import ViewDocumentModal from "../../modals/ViewDocumentModal";
import DashboardFilters from "../../filters/DashboardFilters";
import { DASHBOARD_HEADERS } from "./DashboardHelper";
import { ColumnHeaderType, LoggedUserType } from "../../utils/Types";
import NewGrievanceSearch from "../../modals/NewGrievanceSearchModal";
import { loginSelector } from "../../redux/slices/loginSlice";
import DeleteGrievaceConfirmModal from "../../modals/DeleteGrievaceConfirmModal";
import { blankValueGetter } from "../../utils/Util";
import { toast } from "react-toastify";
import BulkAssignModal from "../../modals/BulkAssignModal";

const Dashboard = () => {
  const user: LoggedUserType = useSelector(loginSelector).user;
  const [selectedFilter, setSelectedFilter] = useState<SearchFilter>(
    {
      mobileNumber: "ALL",
      policyNumber: "ALL",
      status: DEFAULT_OPTION,
      complaintMode: DEFAULT_OPTION,
      department: DEFAULT_OPTION,
      source: DEFAULT_OPTION,
      grievanceType: DEFAULT_OPTION,
      lob: DEFAULT_OPTION,
      requestType: DEFAULT_OPTION,
      createdDate: undefined,
      closureDate: undefined,
    }
  );
  const [openNewModal, setOpenNewModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [count, setCount] = useState(0)
  const [totalCount, setTotalCount] = useState(0)
  const [grievanceID, setGrievanceID] = useState('');
  const [tat, setTAT] = useState('');
  const [created_date, setCreatedDate] = useState('');
  const [closure_date, setClosureDate] = useState('');
  const [reopen_date, setReopenDate] = useState('');
  const [limitStart, setLimitStart] = useState(0)
  const [limitSelected, setLimitSelected] = useState(25)
  const [flag, setFlag] = useState(false)
  const [openForm, setOpenForm] = useState<boolean>(false);
  const [searchTerms, setSearchTerms] = useState<{ [key: string]: string }>({});
  const [openDeleleGrievance, setOpenDeleteGrievance] = useState<boolean>(false);
  const [tableHeaders, setTableHeaders] = useState(DASHBOARD_HEADERS);
  const [openBulkAssignModal, setOpenBulkAssignModal] = useState(false);
  const [viewDocumentModal, setViewDocumentModal] = useState(false);
  const [dashboardData, setDashboardData] = useState<any>([]);
  const [selectAll, setSelectAll] = useState<boolean | undefined>(false);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [selectedData, setSelectedData] = useState<any>([]);
  const [selectedCount, setSelectedCount] = useState<any>(0);

  const dispatch: any = useDispatch();
  const selectedBulkAssignData = useSelector((state: any) => state.grievances.storeSelectedBulkAssignData);
  const {
    storeGrievanceDetailsData,
    storeDepartmentData,
    storeGrievanceData,
    storeDeleteGreivanceRes,
    storeUpdateGrievanceDetails,
    storeGrievanceDocUploadData
  } = useSelector((state: any) => state.grievances);

  const grievanceDashboardData = storeGrievanceData.data?.grievanceDashBoardResponse ?? [];
  const grievanceUpdateResponse = storeUpdateGrievanceDetails ?? {};
  const grievanceDocUploadResponseData = storeGrievanceDocUploadData.response ?? [];
  const departmentData = FormUtils.convertDataList(
    storeDepartmentData.data ?? []
  );

  const getDashboardData = () => {
    dispatch(grievanceDashboardApi(selectedFilter, limitStart, limitSelected, searchTerms))
  }

  const viewDoc = (grievanceID: any) => {
    if (grievanceID) {
      dispatch(getDocsApi(grievanceID))
    }
    setViewDocumentModal(!viewDocumentModal)
  }

  const viewDeleteModal = (grievanceID: any) => {
    setOpenDeleteGrievance(!openDeleleGrievance);
    setGrievanceID(grievanceID || '')

    if (openDeleleGrievance || !grievanceID) {
      if (flag) {
        setTimeout(() => {
          getDashboardData()
          setFlag(false)
        }, 100)
      }
    }
  }

  const toggleBulkAssignModal = (refresh: boolean) => {
    if (!openBulkAssignModal) {
      let nonClosedData = selectedBulkAssignData?.filter((each: any) => {
        return each?.status !== STATUS.CLOSE;
      })
      setSelectedCount(nonClosedData?.length);
    }
    setOpenBulkAssignModal(!openBulkAssignModal);
    if (openBulkAssignModal) {
      if (refresh) {
        setTimeout(() => {
          getDashboardData()
          setFlag(false)
          setSelectAll(false)
          setSelectedRows([])
          setSelectedData([])
          dispatch(clearSelectedBulkAssignData())
        }, 100)
      }
    }
  }

  const toggleNewGrievanceForm = () => {
    setOpenForm(!openForm);
    if (openForm) {
      dispatch(handleCustomerDetailsSearchDataSlice({}))
      dispatch(handleApplicationSearchDataSlice([]))
      dispatch(handleSelectedApplication({}))
      dispatch(handlePolicyDetailsSearchDataSlice({}))
      dispatch(handleSearchDataSlice({}))
    }
  }
  const toggleNewGrievance = () => {
    setOpenNewModal(!openNewModal);
    if (!openNewModal) {
      dispatch(handleCustomerDetailsSearchDataSlice({}))
      dispatch(handleApplicationSearchDataSlice([]))
      dispatch(handleSelectedApplication({}))
      dispatch(handlePolicyDetailsSearchDataSlice({}))
    }
  }
  const toggleViewGrievance = (grievanceID: string | null, tat: string | null, createdDate: string | null, closureDate: string | null, reopenDate: string | null) => {
    setOpenViewModal(!openViewModal);
    setGrievanceID(grievanceID || '')
    setTAT(tat || '')
    setCreatedDate(createdDate || '')
    setClosureDate(closureDate || '')
    setReopenDate(reopenDate || '')
    if (!openViewModal && grievanceID) {
      dispatch(grievanceDetailsApi(grievanceID));
    }
    else {
      dispatch(handleGrievanceDetailsDataSlice([]))
      dispatch(handleGrievanceDocUploadSlice([]))
      dispatch(handleStoreGrievanceFeedbackInfo({}))
      if (flag) {
        setTimeout(() => {
          getDashboardData()
          setFlag(false)
        }, 100)
      }
    }
  }
  const changePaginationLimit = (value: number) => {
    setLimitSelected(Number(value))
  };

  const prevPage = () => {
    if (limitStart >= limitSelected) {
      setLimitStart(limitStart - limitSelected)
    }
  };
  const nextPage = () => {
    if (totalCount > limitStart + limitSelected) {
      setLimitStart(limitStart + limitSelected);
    }
  };

  const onTableAction = (each: any, headerItem: ColumnHeaderType) => {
    if (headerItem.action === CLICK_ACTIONS.VIEW_GRIEVANCE) {
      toggleViewGrievance(each.grievanceId, each.tat, each.createdDate, each.closureDate, each.reopenDate);
    } else if (headerItem.action === CLICK_ACTIONS.VIEW_DOCUMENT) {
      viewDoc(each.grievanceId);
    } else if (headerItem.action === CLICK_ACTIONS.DELETE_GRIEVANCE) {
      viewDeleteModal(each.grievanceId);
    }
  };

  useEffect(() => {
    grievanceDashboardData.forEach((each: any) => {
      if (selectedRows?.includes(each?.grievanceId)) {
        dispatch(addSelectedBulkAssignData(each));
      }
      else {
        dispatch(removeSelectedBulkAssignData(each.grievanceId))
      }
    });
  }, [selectedRows]);

  useEffect(() => {
    grievanceDashboardData?.map((each: any) => {
      dispatch(removeSelectedBulkAssignData(each?.grievanceId))
    })
  }, [selectAll === false])

  useEffect(() => {
    dispatch(clearSelectedBulkAssignData())
    dispatch(getGrievanceTypeMastersApi())
    dispatch(grievanceSourceMastersApi())
    dispatch(grievanceModeMastersApi())
    dispatch(statusMastersApi())
    dispatch(departmentMastersApi())
    dispatch(stateMasterApi())
    dispatch(lineOfBusinessMastersApi())
    dispatch(typeOfRequestMastersApi())
    dispatch(finalDispositionMastersApi())
    dispatch(seasonnMastersApi())
    dispatch(getGrievanceDescriptionsApi())
    dispatch(severityMastersApi())
  }, [])

  useEffect(() => {
    setTimeout(() => {
      getDashboardData()
      setFlag(false)
    }, 100)
  }, [limitStart, limitSelected, flag])

  useEffect(() => {
    if (limitStart > 0) {
      setLimitStart(0)
    }
    else {
      setTimeout(() => {
        getDashboardData()
        setFlag(false)
      }, 100)
    }
  }, [selectedFilter, searchTerms])

  useEffect(() => {
    setTotalCount(storeGrievanceData.data?.totalData)
    setCount(storeGrievanceData.data?.grievanceDashBoardResponse?.length)
    setSelectAll(false);
    setSelectedRows(selectedBulkAssignData?.map((each: any) => { return each.grievanceId; }))
  }, [storeGrievanceData])

  useEffect(() => {
    if (storeDeleteGreivanceRes?.statusId === 'OK') {
      setFlag(true)
      viewDeleteModal(null);
      dispatch(handleStoreDeleteGrievance({}));
    }
  }, [storeDeleteGreivanceRes])

  useEffect(() => {
    const headers = user?.permissions?.includes('delete-grievance')
      ? [...DASHBOARD_HEADERS, {
        name: 'Action',
        field: '',
        sortable: false,
        valueGetter: blankValueGetter,
        clickable: true,
        action: CLICK_ACTIONS.DELETE_GRIEVANCE,
      }]
      : DASHBOARD_HEADERS;
    setTableHeaders(headers);
  }, [user])

  useEffect(() => {
    if (grievanceUpdateResponse?.res?.statusId === 'OK') {
      if (grievanceUpdateResponse?.moveToFreshWorks) {
        toast.success('Ticket moved Freshworks Succesfully.');
      }
      else if (grievanceDocUploadResponseData === 'updated Successfully') {
        toast.success('Document uploaded and grievance updated successfully');
      }
      else {
        const requestType = grievanceUpdateResponse?.requestType; 
        const bbMsg = grievanceUpdateResponse?.res?.bimaBharosaStatus || "";
        const bbFailed = bbMsg.toLowerCase().includes("failed");
        if (Number(requestType) === TYPE_OF_REQUEST_ID.GRIEVANCE) {
          if(bbFailed) {
            toast.warning( <>  Grievance updated successfully.<br /> {bbMsg}  </> );
          } else {
            toast.success( <>  Grievance updated successfully.<br /> {bbMsg}  </> );
          }
        } else {
          toast.success("Grievance updated successfully.");
        }
      }
      setFlag(true)
      toggleViewGrievance(null, null, null, null, null);
      dispatch(handleUpdateGrievanceDetailsSlice({}));
      dispatch(handleGrievanceDocUploadSlice([]));
    }
    else if (grievanceUpdateResponse?.res?.message == 'failed') {
      const bbMsg = grievanceUpdateResponse?.res?.bimaBharosaStatus || "";
      if (grievanceDocUploadResponseData === 'updated Successfully') {
        toast.error('Document uploaded, but grievance update failed');
        dispatch(handleUpdateGrievanceDetailsSlice({}));
        dispatch(handleGrievanceDocUploadSlice([]));
      }
      else {
        toast.error(<>Grievance update failed.<br />  {bbMsg} </>);
        dispatch(handleUpdateGrievanceDetailsSlice({}));
      }
    }
    if (grievanceDocUploadResponseData?.length > 0 && grievanceDocUploadResponseData !== 'updated Successfully') {
      toast.error('Document upload failed');
      dispatch(handleUpdateGrievanceDetailsSlice({}));
      dispatch(handleGrievanceDocUploadSlice([]));
    }
  }, [grievanceUpdateResponse, grievanceDocUploadResponseData])

  return (
    <div style={{ marginBottom: '66px', overflow: 'auto' }}>
      <p className="page-header">Grievances</p>
      <DashboardFilters
        onApplyFilters={setSelectedFilter}
        setSearchTerms={setSearchTerms}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
        <button
          className={
            (user?.permissions?.includes('create-grievance')) ?
              'create-grievance' :
              'create-grievance-no-permission'
          }
          onClick={toggleNewGrievance}
          disabled={!(user?.permissions?.includes('create-grievance')) || (selectedBulkAssignData?.length > 0)}
        >
          Create New Grievance
        </button>
        <button
          className={(user?.permissions?.includes('bulk-assignment')) ? 'bulk-assign' : 'bulk-assign-no-permission'}
          onClick={() => toggleBulkAssignModal(false)}
          disabled={!(selectedBulkAssignData?.length > 0) || !(user?.permissions?.includes('bulk-assignment'))}
        >
          Bulk Assignment
        </button>
        <label style={{ color: "#ffff" }} className={"tooltiptext"}>Unauthorised Access</label>
      </div>

      {openNewModal &&
        <NewGrievanceSearch
          toggle={toggleNewGrievance}
          openModal={openNewModal}
          setFlag={setFlag}
          setOpenNewModal={setOpenForm}
        />
      }

      {openViewModal && storeGrievanceDetailsData.data &&
        <ViewGrievance
          toggle={toggleViewGrievance}
          openModal={openViewModal}
          grievance_id={grievanceID}
          tat={tat}
          createdDate={created_date}
          closureDate={closure_date}
          reopenDate={reopen_date}
          setOpenNewModal={setOpenNewModal}
          setFlag={setFlag}
        />
      }

      {viewDocumentModal &&
        <ViewDocumentModal
          viewDoc={viewDoc}
          openModal={viewDocumentModal}
        />
      }

      {openForm &&
        <NewGrievance
          toggle={toggleNewGrievanceForm}
          openModal={openForm}
          setFlag={setFlag}
        />
      }

      {openDeleleGrievance &&
        <DeleteGrievaceConfirmModal
          toggle={viewDeleteModal}
          openModal={openDeleleGrievance}
          grievanceId={grievanceID}
          setFlag={setFlag}
        />
      }

      {openBulkAssignModal &&
        <BulkAssignModal
          toggle={toggleBulkAssignModal}
          openModal={openBulkAssignModal}
          selectedData={selectedBulkAssignData}
          setFlag={setFlag}
          setSelectedCount={setSelectedCount}
          selectedCount={selectedCount}
        />
      }

      <div className="table-container">
        <TableComponent
          onAction={onTableAction}
          data={grievanceDashboardData}
          style={{ marginBottom: '66px' }}
          columnHeaders={tableHeaders}
          setSearchTerms={setSearchTerms}
          searchTerms={searchTerms}
          masterData={departmentData}
          selectAll={selectAll}
          setSelectAll={setSelectAll}
          selectedRows={selectedBulkAssignData?.map((each: any) => { return each.grievanceId })}
          setSelectedRows={setSelectedRows}
        />

        {(storeGrievanceData.statusId == 'INTERNAL_SERVER_ERROR' || storeGrievanceData.data == 'no data found') &&
          <p className="nodata">Data Not Found</p>
        }
      </div>


      <Footer
        count={count} totalCount={totalCount}
        changePaginationLimit={changePaginationLimit}
        nextPage={nextPage}
        prevPage={prevPage}
        limitSelected={limitSelected}
        limitStart={limitStart}
      />
    </div>
  );
};

export default Dashboard;
